module.exports = __webpack_public_path__ + "img/istockphoto.9e613b59.jpg";